import CableCategoryRequests from '../../server/cableCategory';
import { addLoading, removeLoading } from './loading';

export const getAllCableCategory = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await CableCategoryRequests.getAllCableCategory(limit, skip, search, orderBy, field);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getCableCategoryOptions = (search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await CableCategoryRequests.getCableCategoryOptions(search);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createCableCategory = newCableCategory => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CableCategoryRequests.createCableCategory(newCableCategory);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateCableCategory = updCableCategory => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CableCategoryRequests.updateCableCategory(updCableCategory);
  } finally {
    dispatch(removeLoading());
  }
};
